import { render, staticRenderFns } from "./SDate.vue?vue&type=template&id=46e6d21b&"
import script from "./SDate.vue?vue&type=script&lang=js&"
export * from "./SDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports